import { createContext, useContext } from 'react';

/**
 * Minimal chat-scoped context exposing the active Task id to deep descendants
 * of the chat render tree (Messages → Step → ModelRequestResponse → …), so a
 * component like the interrupted-turn Retry button can act on the task without
 * prop-drilling `taskId` through every intermediate component.
 *
 * Provided once by ChatView; consumed where needed. Null outside a chat.
 */
export const ChatTaskContext = createContext<{
  taskId: string;
  /** Is the turn working RIGHT NOW? ChatView derives this from the task's
   *  status and the latest step (it is what shows the Stop button), and
   *  passes it down because a deep descendant cannot tell on its own: the
   *  task node it can reach through the store is not reliably up to date,
   *  and one response's flags do not say whether the TURN is still going. */
  isWorking: boolean;
} | null>(null);

export function useChatTaskId(): string | null {
  return useContext(ChatTaskContext)?.taskId ?? null;
}

/** Whether the chat's turn is working right now. False outside a chat. */
export function useChatTaskIsWorking(): boolean {
  return useContext(ChatTaskContext)?.isWorking ?? false;
}
